<template>
    <div class="queue card">
        <div class="queue__title"><i class="far fa-user-clock"></i> Students - In Queue <span v-if="data.length > 0"
                class="queue__count">({{ data.length }})</span><button type="button"
                class="btn btn-icon btn-sm btn-light-primary float-right" data-toggle="tooltip" data-placement="bottom"
                title="Add Item" @click="addQueueItem()"><i class="far fa-user-plus"></i></button></div>
        <div class="card-body">
            <transition name="fade">
                <div v-if="queueNotificationStatus" :class="[getQueueNotificationClass, 'alert']">
                    <i class="far fa-exclamation-circle"></i> {{ queueNotificationMessage }}
                </div>
            </transition>
            <div v-if="getQueueStatus">
                <div v-if="queueStatus">
                    <div v-for="user in data" :key="user.username" class="queue__item" :id="'item' + user.itemid ">
                        <queue-item :user="user" @refreshQueue="refreshQueue"
                            @setNotificationMessage="setNotificationMessage" :counsellors="counsellorsData"
                            :counsellorsResult="counsellorsResult" :waitingAreasData="waitingAreasData"></queue-item>
                    </div>
                </div>
                <div v-else>
                    <div class="queue__message">
                        <div v-if="queueAlert == 'success'" class="alert alert-success">
                            <i class="far fa-check"></i> {{ queueMessage }}
                        </div>
                        <div v-else-if="queueAlert == 'info'" class="alert alert-primary">
                            <i class="far fa-bells"></i> {{ queueMessage }}
                        </div>
                        <div v-else class="alert alert-warning">
                            <i class="far fa-exclamation-circle"></i> {{ queueMessage }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="queue__load">
                <i class="fas fa-spinner fa-spin fa-2x"></i>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import QueueItem from './QueueItem';

export default {
    name: 'queue',
    components: {
        QueueItem
    },
    props: {
        counsellorsData: {
            type: Array,
            required: true
        },
        counsellorsResult: {
            type: String,
            required: true
        },
        data: {
            type: Array,
            required: true
        },
        message: {
            type: String,
            required: true
        },
        result: {
            type: String,
            required: true
        },
        waitingAreasData: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            queueNotificationMessage: '',
            queueNotificationStatus: false,
            queueNotificationTimeout: '',
            queueNotificationType: 'success',
            queueAlert: 'success',
            queueMessage: '',
            queueStatus: false
        }
    },
    methods: {
        addQueueItem() {
            // Route with user ID
            this.$router.push({
                name: 'queue-add'
            })
        },
        refreshQueue() {
            this.$emit('refreshQueue');
        },
        setNotificationMessage(alert) {
            const that = this;

            // Set alert
            if (alert.message) {
                this.queueNotificationMessage = alert.message;

                // Set type if it exists87 
                if (alert.type) {
                    this.queueNotificationType = alert.type;
                }

                // Set alert to true
                this.queueNotificationStatus = true;
            }

            // Set timeout
            if (!this.queueNotificationTimeout) {
                this.queueNotificationTimeout = setTimeout(function () {
                    that.queueNotificationStatus = false;
                    that.queueNotificationTimeout = '';
                }, 5000);
            }
        }
    },
    computed: {
        getQueueNotificationClass() {
            return {
                'alert-success': this.queueNotificationType == 'success',
                'alert-warning': this.queueNotificationType.match(/warning/i),
                'alert-danger': this.queueNotificationType.match(/danger/i) || this.queueNotificationType == ''
            }
        },
        getQueueStatus() {
            const that = this;

            // Load handler
            if (this.result) {
                // Success
                if (this.result.match(/ok/i)) {
                    if (this.data.length > 0) {
                        // Set queue status
                        this.queueStatus = true;
                    } else {
                        // Set alert and message
                        this.queueStatus = false;
                        this.queueAlert = 'info';
                        this.queueMessage = 'There are currently no students in queue.';
                    }
                } else {
                    // Set alert and message
                    this.queueStatus = false;
                    this.queueAlert = '';
                    this.queueMessage = 'Student queue data could not be retrieved. Please contact your system administrator.';
                }

                // Return
                return true;
            } else {
                // Return
                return false;
            }
        }
    },
    mounted() {
        // Tooltip inialization
        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover'
        })

        $('[data-toggle="tooltip"]').on('click', function () {
            $(this).tooltip('hide')
        })
    }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.queue {
    border: none;
    color: #595d6e;
    -webkit-box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
    box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
    background-color: #ffffff;
    margin-bottom: 20px;
    border-radius: 4px;
}

.queue__count {
    color: #ffb822;
}

@keyframes blink {
    0% { box-shadow: 0 0 16px #5d78ff; }
    50% { box-shadow: none; }
    100% { box-shadow: 0 0 16px #5d78ff; }
}

@-webkit-keyframes blink {
    0% { box-shadow: 0 0 16px #5d78ff; }
    50% { box-shadow: 0 0 0; }
    100% { box-shadow: 0 0 16px #5d78ff; }
}

.queue__item-highlight {
    -webkit-animation: blink 1.0s linear infinite;
    -moz-animation: blink 1.0s linear infinite;
    -ms-animation: blink 1.0s linear infinite;
    -o-animation: blink 1.0s linear infinite;
    animation: blink 1.0s linear infinite;
    border-radius: 4px;
}

.queue__item {
    padding-top: .5rem;
    padding-bottom: .5rem;
    border-bottom: 1px dashed #ebedf2;
}

.queue__item:last-child {
    border: none;
}

.queue__load {
    color: #5d78ff;
    text-align: center;
}

.queue__title {
    border-bottom: 1px solid #ebedf2;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #48465b;
    font-size: 16px;
    font-weight: 700;
    min-height: 64px;
    padding: 16px 20px;
}

.queue__title>i {
    color: #ffb822;
    font-size: 1.25rem;
}
</style>